import React from 'react';
import { Link } from 'react-router-dom';

const TEAM = [
  { name:'Amir Khan', role:'Founder & CEO', exp:'18 Years Experience', img:'https://i.pravatar.cc/150?img=60', bio:"Born and raised in Srinagar, Amir has been guiding travellers through Kashmir's hidden gems since 2006." },
  { name:'Farida Wani', role:'Head of Operations', exp:'12 Years Experience', img:'https://i.pravatar.cc/150?img=47', bio:"Farida ensures every booking is flawless, from houseboat selection to last-minute itinerary changes." },
  { name:'Imran Bhat', role:'Lead Tour Guide', exp:'15 Years Experience', img:'https://i.pravatar.cc/150?img=33', bio:"Imran's stories about Kashmir's culture, cuisine and history bring every destination to life." },
  { name:'Razia Malik', role:'Customer Experience', exp:'8 Years Experience', img:'https://i.pravatar.cc/150?img=44', bio:"Razia is your 24/7 support hero — she has resolved over 10,000 traveller queries with a smile." },
];

const MILESTONES = [
  { year:'2008', event:'Founded in Srinagar with 3 packages and a single houseboat partnership' },
  { year:'2012', event:'Expanded to Ladakh tours, crossed 1,000 happy travellers milestone' },
  { year:'2016', event:'Received J&K Tourism Award for Best Travel Agency of the Year' },
  { year:'2019', event:'Launched corporate & group tour division, 5,000+ travellers served' },
  { year:'2022', event:'Introduced luxury houseboat collection and premium SUV fleet' },
  { year:'2024', event:'5,000+ families, 50+ packages, 14+ years — and still growing' },
];

export default function About() {
  return (
    <div>
      <div className="page-hero" style={{ backgroundImage:"url('https://images.unsplash.com/photo-1706628416838-0325e29521ee?w=1600&q=85')" }}>
        <div className="container" style={{ position:'relative', zIndex:1 }}>
          <div className="breadcrumb">
            <Link to="/">Home</Link><span className="breadcrumb-sep">›</span><span>About Us</span>
          </div>
          <h1>Our Story</h1>
          <p>14+ years of crafting unforgettable Kashmir journeys with passion, expertise, and heart.</p>
        </div>
      </div>

      {/* Mission */}
      <section className="section" style={{ background:'var(--surface)' }}>
        <div className="container">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'4rem', alignItems:'center' }}>
            <div>
              <span className="section-label">Our Mission</span>
              <h2 style={{ fontFamily:"'Playfair Display',serif", marginBottom:'0.75rem' }}>More Than a Trip —<br/><span style={{ fontStyle:'italic', color:'var(--secondary)' }}>A Lifetime Memory</span></h2>
              <div className="divider" />
              <p style={{ lineHeight:1.8, marginBottom:'1.25rem' }}>
                Query Tours and Travels was born from a deep love for our homeland. We believe every traveller deserves to experience Kashmir the way we do — not as a tourist, but as a guest welcomed into the valley's soul.
              </p>
              <p style={{ lineHeight:1.8, marginBottom:'2rem' }}>
                We handpick every houseboat, vet every driver, and train every guide. We don't just sell packages — we craft experiences that connect you to the real Kashmir: its people, food, culture, and breathtaking landscapes.
              </p>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'1rem' }}>
                {[['5000+','Happy Travellers'],['14+','Years of Experience'],['50+','Tour Packages'],['4.9★','Average Rating']].map(([num,lbl],i) => (
                  <div key={i} style={{ background:'var(--bg)', borderRadius:'var(--radius-md)', padding:'1.25rem', textAlign:'center', border:'1px solid var(--border)' }}>
                    <div style={{ fontFamily:"'Playfair Display',serif", fontSize:'1.8rem', fontWeight:700, color:'var(--primary)' }}>{num}</div>
                    <div style={{ fontSize:'0.82rem', color:'var(--muted)', fontWeight:600, textTransform:'uppercase', letterSpacing:'0.05em' }}>{lbl}</div>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ borderRadius:'var(--radius-xl)', overflow:'hidden', height:480 }}>
              <img src="https://images.unsplash.com/photo-1595815771614-ade9d652a65d?w=800&q=80" alt="Kashmir Dal Lake Houseboat" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section" style={{ background:'var(--bg)' }}>
        <div className="container">
          <div className="section-header text-center">
            <span className="section-label">Our Values</span>
            <h2 className="section-title">What We Stand For</h2>
            <div className="divider divider-center" />
          </div>
          <div className="grid-3" style={{ gap:'1.5rem' }}>
            {[
              { icon:'🤝', title:'Trust & Transparency', desc:'No hidden fees, no false promises. We believe honest travel planning is the foundation of every great journey.' },
              { icon:'💎', title:'Luxury at Heart', desc:'We believe comfort and luxury should be accessible. Every detail — from bed linens to vehicle condition — is carefully curated.' },
              { icon:'🌱', title:'Responsible Tourism', desc:'We support local artisans, hire from local communities, and promote eco-conscious travel practices across the valley.' },
              { icon:'🛡️', title:'Safety First', desc:'Every itinerary includes emergency contacts, regular check-ins, and real-time monitoring — your safety is non-negotiable.' },
              { icon:'🎯', title:'Personalisation', desc:'No two travellers are the same. Every package is tailored to your unique preferences, budget, and travel style.' },
              { icon:'💬', title:'Always Accessible', desc:'Our team is available 24 hours a day, 7 days a week — whether you need help mid-trek or a midnight restaurant recommendation.' },
            ].map((v,i) => (
              <div key={i} className="feature-card">
                <div className="feature-icon icon-primary">{v.icon}</div>
                <h4 style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, color:'var(--heading)', marginBottom:'0.6rem' }}>{v.title}</h4>
                <p style={{ fontSize:'0.92rem', lineHeight:1.7, margin:0 }}>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="section" style={{ background:'var(--surface)' }}>
        <div className="container">
          <div className="section-header text-center">
            <span className="section-label">Our Journey</span>
            <h2 className="section-title">14 Years of Query Tours and Travels</h2>
            <div className="divider divider-center" />
          </div>
          <div style={{ maxWidth:720, margin:'0 auto' }}>
            {MILESTONES.map((m,i) => (
              <div key={i} style={{ display:'flex', gap:'1.5rem', marginBottom:'1.5rem' }}>
                <div style={{ width:80, minWidth:80, textAlign:'right' }}>
                  <span style={{ fontFamily:"'Poppins',sans-serif", fontWeight:800, fontSize:'1rem', color:'var(--primary)' }}>{m.year}</span>
                </div>
                <div style={{ width:2, background:'var(--border)', position:'relative', flexShrink:0 }}>
                  <div style={{ position:'absolute', top:4, left:'50%', transform:'translateX(-50%)', width:12, height:12, borderRadius:'50%', background:'var(--secondary)', border:'2px solid #fff', boxShadow:'0 0 0 2px var(--secondary)' }} />
                </div>
                <div style={{ paddingTop:'0.1rem', paddingBottom:'1.5rem' }}>
                  <p style={{ lineHeight:1.7, color:'var(--body)', margin:0 }}>{m.event}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section" style={{ background:'var(--bg)' }}>
        <div className="container">
          <div className="section-header text-center">
            <span className="section-label">Meet the Team</span>
            <h2 className="section-title">The People Behind<br/>Your Perfect Trip</h2>
            <div className="divider divider-center" />
          </div>
          <div className="grid-4" style={{ gap:'1.5rem' }}>
            {TEAM.map((member,i) => (
              <div key={i} style={{ background:'var(--surface)', borderRadius:'var(--radius-lg)', overflow:'hidden', boxShadow:'var(--shadow-sm)', border:'1px solid var(--border)', transition:'all 0.25s', cursor:'default' }}
                onMouseEnter={e => { e.currentTarget.style.transform='translateY(-6px)'; e.currentTarget.style.boxShadow='var(--shadow-lg)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow='var(--shadow-sm)'; }}>
                <div style={{ height:200, overflow:'hidden' }}>
                  <img src={member.img} alt={member.name} style={{ width:'100%', height:'100%', objectFit:'cover', transition:'transform 0.5s' }} />
                </div>
                <div style={{ padding:'1.5rem' }}>
                  <h4 style={{ fontFamily:"'Playfair Display',serif", color:'var(--heading)', marginBottom:'0.25rem' }}>{member.name}</h4>
                  <div style={{ fontFamily:"'Poppins',sans-serif", fontSize:'0.78rem', fontWeight:700, color:'var(--secondary-dark)', textTransform:'uppercase', letterSpacing:'0.06em', marginBottom:'0.25rem' }}>{member.role}</div>
                  <div style={{ fontSize:'0.78rem', color:'var(--muted)', marginBottom:'0.85rem' }}>⭐ {member.exp}</div>
                  <p style={{ fontSize:'0.85rem', lineHeight:1.65, color:'var(--body)', margin:0 }}>{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ background:'linear-gradient(135deg,#0F4C81,#3AAFA9)', padding:'5rem 0', textAlign:'center' }}>
        <div className="container">
          <h2 style={{ color:'#fff', fontFamily:"'Playfair Display',serif", fontSize:'clamp(1.6rem,3vw,2.4rem)', marginBottom:'1rem' }}>
            Ready to Experience Kashmir with Us?
          </h2>
          <p style={{ color:'rgba(255,255,255,0.85)', maxWidth:480, margin:'0 auto 2rem', lineHeight:1.7 }}>
            Join 5,000+ families who have trusted us with their Kashmir dreams.
          </p>
          <div style={{ display:'flex', gap:'1rem', justifyContent:'center', flexWrap:'wrap' }}>
            <Link to="/tours" className="btn btn-accent btn-lg">Browse Packages</Link>
            <Link to="/contact" className="btn btn-outline-white btn-lg">Contact Us</Link>
          </div>
        </div>
      </section>

      <a href="https://wa.me/917006478276" target="_blank" rel="noopener noreferrer" className="whatsapp-fab">💬</a>
      <style>{`
        @media (max-width:900px) {
          div[style*="grid-template-columns: 1fr 1fr"] { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
}
